import loader_review2 from "../../../../assets/FollowupVaqV2/img/loader-review2.svg";
import logowhite from "../../../../assets/FollowupS4/img/logo-white.png";

const LoaderOD = ({ showUserName = "", showLoad }) => {
  return (
    <>
      <section className="banner qs-section form-style">
        <div className="container">
          <div>
            <div className="brand">
              <div className="logo pt-3 text-center">
                <a>
                  <img src={logowhite} style={{ height: 60 }} alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="container d-flex align-items-center justify-content-center vh-100">
          <div
            className={`loader-wrap text-center text-light ${
              showLoad ? "show" : "hide"
            } `}
          >
            <div>
              <img style={{ height: 80 }} src={loader_review2} alt />
              {showUserName && (
                <>
                  <h6 className="mt-3">
                    {showUserName} we need a few more details before we can
                    proceed.
                  </h6>
                  <p>(Don't worry, it will only take a minute.)</p>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default LoaderOD;
